import { MetaFunction } from '@remix-run/node';
import { Link } from '@remix-run/react';
import { HistoryIcon } from 'lucide-react';
import { Container } from '~/components/Container';
import { Layout } from '~/components/Layout';
import { PageHeading } from '~/components/PageHeading';
import { appendMetaTitleSuffix } from '~/lib/utils/meta';

export const loader = async () => {
  return {};
};

export const meta: MetaFunction = () => {
  return [
    { title: appendMetaTitleSuffix('プライバシーポリシー') },
    { name: 'description', content: 'StompBase（ストンプベース）のプライバシーポリシーです。' },
    { name: 'robots', content: 'noindex' },
  ];
};

const PrivacyRoute = () =>  {
  return (
    <Layout>
      <Container>
        <div className={'max-w-[864px] mx-auto'}>
          <PageHeading>
            プライバシーポリシー
          </PageHeading>

          <div className={'flex items-center text-sm text-slate-400 mb-4'}>
            <HistoryIcon className={'h-4 w-4 mr-1'} />
            2024-07-03
          </div>

          <div className={'text-sm leading-relaxed mb-6'}>
            StompBase: ストンプベース（以下「当サイト」といいます）は、本ウェブサイト上で提供するサービス（以下「本サービス」といいます）における、ユーザーの個人情報の取扱いについて以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            個人情報の利用目的
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            当サイトでは、お問い合わせフォームでのお問い合わせなどの際に、お名前、メールアドレス等の個人情報をご登録いただく場合がございます。
            これらの個人情報は質問に対する回答や必要な情報を電子メールなどをでご連絡する場合に利用させていただくものであり、それ以外の目的では利用いたしません。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            個人情報の第三者への開示
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            当サイトでは、個人情報は適切に管理し、以下に該当する場合を除いて第三者に開示することはありません。<br/>
            ・ご本人の同意がある場合<br/>
            ・法令に基づき開示、提供が必要となる場合
          </div>

          <h2 className="text-lg font-semibold mb-2">
            個人情報の開示、訂正、追加、削除、利用停止
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            ご本人からの個人データの開示、訂正、追加、削除、利用停止のご希望の場合には、ご本人であることを確認させていただいた上、速やかに対応させていただきます。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            Cookie（クッキー）
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            当サイトでは、一部のコンテンツについて情報の収集にCookieを使用しています。<br/>
            Cookieは、ユーザーがサイトを訪れた際に、そのユーザーのコンピュータ内に記録されます。<br/>
            ただし、記録される情報には、ユーザー名やメールアドレスなど、個人を特定するものは一切含まれません。<br/>
            また、当サイトではユーザーの方々がどのようなサービスに興味をお持ちなのかを分析したり、ウェブ上での効果的な広告の配信のためにこれらを利用させていただく場合があります。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            アクセス解析ツールについて
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。<br/>
            このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。<br/>
            このトラフィックデータは匿名で収集されており、個人を特定するものではありません。<br/>
            この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。<br/>
            この規約に関して、詳しくは
            <Link
              to={'https://marketingplatform.google.com/about/analytics/terms/jp/'}
              target={'_blank'}
              className={'text-indigo-600 hover:underline hover:text-indigo-700 mx-1'}
              rel="noreferrer"
            >
              こちら
            </Link>
            をご参照ください。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            プライバシーポリシーの変更
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            ・本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく変更することができるものとします。<br/>
            ・当サイトが別途定める場合を除いて、変更後のプライバシーポリシーは本サイトに掲載したときから効力を生じるものとします。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            お問い合わせ
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            本ポリシーに関するお問い合わせは、
            <Link
              to={`https://forms.gle/QE4BJedNudffqRUA9`}
              className={'text-indigo-600 hover:underline hover:text-indigo-700 mx-1'}
              target={'_blank'}
              rel="noreferrer"
            >
              お問い合わせ
            </Link>
            よりお願いいたします。
          </div>
        </div>
      </Container>
    </Layout>
  );
}

export default PrivacyRoute;